var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full overflow-hidden rounded mx-auto"},[_c('Chats')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }